import React, { useEffect, useRef, useState } from 'react';
import { AgentSideMessages, MessageSideEnum, useChat, SessionManagement } from './ChatContext';
import { GlobalOperations } from '../../Controller/Common/GlobalOperations';
import { Modal, Button } from 'react-bootstrap';  // Modal ve diğer bileşenler 
import { DisplayType, StatusEnum, StatusMessageProvider } from '../Components/CoreComponents/StatusMessage';
import ReportChat from './ReportChat';
import ExistingReportsPopup from './ExistingReportsPopup';

const MessageInput: React.FC = () => {
    const { addMessage, messages, activeSessions, setTypingUsers, setGlobalInputValue, currentSession } = useChat(); // activeSessions ile oturumları alıyoruz
    const [inputValue, setInputValue] = useState('');
    const [showOptions, setShowOptions] = useState(false);
    const [showModal, setShowModal] = useState(false); // Modal state 
    const optionsRef = useRef<HTMLDivElement>(null);
    const [isTyping, setIsTyping] = useState(false);  // Kullanıcının yazma durumunu takip etmek için

    const [showExistingReports, setShowExistingReports] = useState(false);



    const [selectedSession, setSelectedSession] = useState<SessionManagement | null>(null); // Seçili oturum bilgisi

    // inputValue her değiştiğinde setGlobalInputValue çağrılır
    useEffect(() => {
        setGlobalInputValue(inputValue);
    }, [inputValue, setGlobalInputValue]);  // inputValue değiştiğinde bu effect çalışır

    const sendMessage = async (message: string) => {
        if (GlobalOperations.ActiveSessionId !== 0) {
            const request = {
                message,
                sessionId: GlobalOperations.ActiveSessionId,
                agentLoginToken: GlobalOperations.UserToken || '',
                agentHub: GlobalOperations.ConnectionHubId || ''
            };

            try {
                if (GlobalOperations.SignalRConnection == null) {
                    console.error("SignalR bağlantısı yok.");
                    return;
                }

                let response: boolean = await GlobalOperations.SignalRConnection.invoke("sendMessageByAgent", request);
                if (!response) return;

                let newMessage: AgentSideMessages = {
                    messageContent: message,
                    messageOwnerName: GlobalOperations.UserName,
                    messageDateUtc: new Date().getTime(),
                    messageSide: MessageSideEnum.Agent
                };
                addMessage(newMessage);

            } catch (error) {
                console.error('Mesaj gönderme hatası:', error);
            }
        } else {
            console.error('Mesaj göndermek için oturum seçilmedi veya kullanıcı verisi eksik.');
        }
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (inputValue.trim()) {
            sendMessage(inputValue);
            setInputValue('');
            setIsTyping(false);  // Mesaj gönderildiğinde yazma durumu false olur
            setTypingUsers(GlobalOperations.ActiveSessionId, GlobalOperations.UserName, false);
        }
    };


    const typingTimer = useRef<number | null>(null); // <number | null> tip tanımlaması yapıyoruz.
    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (inputValue.trim()) {
                sendMessage(inputValue);
                setInputValue('');
                setIsTyping(false);
                setTypingUsers(GlobalOperations.ActiveSessionId, GlobalOperations.UserName, false);
                typingTimer.current = null;
                return;
            }
        }

        // Zaten yazıyorsa, tekrar tetiklemeye gerek yok
        if (!isTyping) {
            setIsTyping(true);  // İlk kez yazma başladığında yazma durumunu tetikle
            setTypingUsers(GlobalOperations.ActiveSessionId, GlobalOperations.UserName, true);
        }




        // Zamanlayıcıyı sıfırlamak (yeni keydown sırasında)
        if (typingTimer.current) {
            clearTimeout(typingTimer.current); // Eğer önceki bir zamanlayıcı varsa, iptal et.
        }

        // Yeni bir 4 saniyelik zamanlayıcı başlatmak
        typingTimer.current = window.setTimeout(() => {
            if (isTyping) {
                setIsTyping(false);
                setTypingUsers(GlobalOperations.ActiveSessionId, GlobalOperations.UserName, false);
            }
        }, 4000);
    };


    const handleKeyUp = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {

    };

    const toggleOptions = () => {
        setShowOptions(!showOptions);
    };

    const handleClickOutside = (e: MouseEvent) => {
        if (optionsRef.current && !optionsRef.current.contains(e.target as Node)) {
            setShowOptions(false);
        }
    };

    useEffect(() => {
        if (showOptions) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showOptions]);

    useEffect(() => {
        // Sidebar'dan seçilen aktif oturum bilgilerini alıyoruz
        const activeSession = activeSessions.find(session => session.sessionId === GlobalOperations.ActiveSessionId);
        if (activeSession) {
            setSelectedSession(activeSession); // Seçili oturumu kaydediyoruz
        }
    }, [activeSessions]);

    // Modal açma ve kapama işlemleri
    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const handleModalClose = () => {
        setShowModal(false);
    };



    return (
        <div>
            <form onSubmit={handleSubmit} className="message-input" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <textarea
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onKeyUp={handleKeyUp}
                    placeholder="Mesajınızı Yazınız..."
                    rows={inputValue.split('\n').length}
                    style={{
                        width: '90%',
                        resize: 'none',
                        padding: '10px',
                        fontSize: '16px',
                        boxSizing: 'border-box',
                        borderRadius: '4px',
                        marginRight: '10px'
                    }}
                />
                <div style={{ position: 'relative' }}>
                    <button type="button" onClick={toggleOptions} style={{ whiteSpace: 'nowrap' }}>İşlem Yap</button>
                    {showOptions && (
                        <div ref={optionsRef} style={{
                            position: 'absolute',
                            bottom: '40px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            backgroundColor: '#fff',
                            border: '1px solid #ccc',
                            borderRadius: '5px',
                            padding: '10px',
                            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                            width: '200px',
                            zIndex: 1
                        }}>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                <li style={{ padding: '5px 0' }}>
                                    <button type="button" onClick={handleShowModal} style={{
                                        width: '100%',
                                        border: 'none',
                                        cursor: 'pointer',
                                        padding: '5px'
                                    }}>Yeni Rapor Oluştur</button>
                                </li>
                                <li style={{ padding: '5px 0' }}>
                                    <button
                                        type="button"
                                        onClick={() => setShowExistingReports(true)}  // Modal'ı açmak için setShowExistingReports'i tetikledik
                                        style={{
                                            width: '100%',
                                            border: 'none',
                                            cursor: 'pointer',
                                            padding: '5px'
                                        }}>
                                        Eski Rapora Ekle
                                    </button>
                                </li>

                            </ul>
                        </div>
                    )}
                </div>
            </form>

            {showExistingReports && (
                <StatusMessageProvider>
                    <ExistingReportsPopup
                        serviceId={currentSession?.serviceId || 0}  // Gerekli props'ları geçiyoruz
                        sessionOwnerTel={currentSession?.sessionOwnerTel || ''}
                        handleClose={() => setShowExistingReports(false)}  // Modal'ı kapatma fonksiyonu
                    />
                </StatusMessageProvider>
            )}

            {/* Modal Bileşeni */}
            <Modal show={showModal} onHide={handleCloseModal} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Yeni Rapor Oluştur</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <StatusMessageProvider>
                        {selectedSession && (
                            <ReportChat handleCloseModal={handleCloseModal} />
                        )}
                    </StatusMessageProvider>
                </Modal.Body>
            </Modal>

        </div>
    );
};

export default MessageInput;
